import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DependencyTreeGuard } from 'app/core/guards/dependency-tree.guard';
import { OrderFilterValuesLoadGuard } from 'app/core/guards/order-filter-values-load.guard';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { EditOrderTemplateGuard } from 'app/core/store/template/order-template-edit.resolve';
import { GetEmailActorsGuard } from '../../core/store/email-actors/email-actors.resolve';
import { CreateOrderFromTemplateGuard } from '../../core/store/order-detail/order-detail-create-from-template.resolve';
import { CreateOrderGuard } from '../../core/store/order-detail/order-detail-create.resolve';
import { GetOrderGuard } from '../../core/store/order-detail/order-detail.resolve';
import { OrderEditContainer } from '../order/order-edit-container/order-edit.container';

const routes: Routes = [
  {
    path: 'orders/new',
    component: OrderEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [CreateOrderGuard, GetEmailActorsGuard],
    },
  },
  {
    path: 'orders/copy',
    component: OrderEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [OrderFilterValuesLoadGuard, AuthorizationGuard],
    },
  },
  {
    path: 'orders/template/new',
    component: OrderEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [OrderFilterValuesLoadGuard, CreateOrderGuard, AuthorizationGuard],
      authorization: 'ORDER.CREATE_TEMPLATE',
      createTemplate: true,
    },
  },
  {
    path: 'orders/template/copy',
    component: OrderEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [OrderFilterValuesLoadGuard, AuthorizationGuard],
      authorization: 'ORDER.CREATE_TEMPLATE',
      createTemplate: true,
    },
  },
  {
    path: 'orders/template/edit/:templateId',
    component: OrderEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [EditOrderTemplateGuard],
      createTemplate: true,
      type: 'ORDER',
    },
  },
  {
    path: 'orders/:etmOrderNumber',
    component: OrderEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [GetOrderGuard],
    },
  },
  {
    // Not used
    path: 'orders/:etmOrderNumber/edit',
    component: OrderEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [OrderFilterValuesLoadGuard, AuthorizationGuard],
      authorization: 'ORDER.UPDATE',
    },
  },
  {
    path: 'orders/new/fromTemplate/:templateId',
    component: OrderEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [CreateOrderFromTemplateGuard],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrderRoutingModule {}
